import { render } from "./RoomDetails.vue?vue&type=template&id=45f3ec33"
import script from "./RoomDetails.vue?vue&type=script&lang=js"
export * from "./RoomDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__